
(function () {
  'use strict';

  function initCoursePortal() {
    const planSelect = document.getElementById('ContactForm-plan');

    // Sync pricing card CTA selection to the form dropdown
    document.querySelectorAll('.choose-plan').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const target = (btn.dataset.plan || '').toLowerCase().trim();

        if (planSelect && target) {
          const matched = [...planSelect.options].find(function (option) {
            const optVal = option.value.toLowerCase().trim();
            const optText = option.text.toLowerCase().trim();

            return (
              optVal === target ||
              optText === target ||
              optVal.includes(target) ||
              target.includes(optVal) ||
              optText.includes(target)
            );
          });

          if (matched) {
            planSelect.value = matched.value;
          }
        }

        const formBox = document.getElementById('enquire') || document.querySelector('.course-leadbox');

        if (formBox) {
          formBox.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          setTimeout(function () {
            const nameField = document.getElementById('ContactForm-name');

            if (nameField) {
              nameField.focus({ preventScroll: true });
            }
          }, 350);
        }
      });
    });

    // Exclusive accordion helper: keep only one item open at a time
    function setupExclusiveAccordion(containerSelector) {
      document.querySelectorAll(containerSelector).forEach(function (container) {
        const detailsList = container.querySelectorAll('details');
        if (!detailsList.length) return;

        // Ensure only one item is open initially
        let foundOpen = false;
        detailsList.forEach(function (detail) {
          if (detail.open) {
            if (foundOpen) {
              detail.removeAttribute('open');
            } else {
              foundOpen = true;
            }
          }
        });

        detailsList.forEach(function (detail) {
          if (detail.dataset.accordionBound === 'true') return;
          detail.dataset.accordionBound = 'true';

          detail.addEventListener('toggle', function () {
            if (detail.open) {
              const currentContainer = detail.closest(containerSelector);
              if (currentContainer) {
                currentContainer.querySelectorAll('details').forEach(function (sibling) {
                  if (sibling !== detail && sibling.open) {
                    sibling.removeAttribute('open');
                  }
                });
              }
            }
          });
        });
      });
    }

    // Accordions: keep only one item open at a time for curriculum modules and FAQ items
    setupExclusiveAccordion('.course-months-list');
    setupExclusiveAccordion('.course-faq-list');

    // Restore the hero section position when hash is #enquire, #ContactForm or after form submission
    if (
      window.location.hash === '#ContactForm' ||
      window.location.hash === '#enquire' ||
      window.location.search.includes('contact_posted=true')
    ) {
      const target = document.getElementById('enquire') || document.querySelector('.course-leadbox');
      if (target) {
        target.scrollIntoView({
          behavior: 'auto',
          block: 'start'
        });
      }
    }
  }

  // Helper for initiating direct file downloads
  async function triggerFileDownload(url) {
    if (!url) return;

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('Download failed');

      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = objectUrl;
      link.download = url.split('/').pop().split('?')[0] || 'syllabus-brochure';

      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(function () {
        URL.revokeObjectURL(objectUrl);
      }, 1000);
    } catch (error) {
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }

  // Course brochure lead-capture popup logic
  function initCourseBrochurePopup() {
    let lastActiveElement = null;

    function openPopup(popup) {
      if (!popup) return;
      lastActiveElement = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('course-popup-locked');

      const nameInput = popup.querySelector('input[name="contact[name]"]');
      if (nameInput) {
        setTimeout(function () {
          nameInput.focus();
        }, 120);
      }
    }

    function closePopup(popup) {
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('course-popup-locked');

      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    // Trigger button clicks to open popup
    document.querySelectorAll('[data-course-popup-open]').forEach(function (btn) {
      if (btn.dataset.popupBound === 'true') return;
      btn.dataset.popupBound = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const popupId = btn.dataset.coursePopupOpen;
        const popup = document.getElementById(popupId);
        openPopup(popup);
      });
    });

    // Close buttons and backdrop click
    document.querySelectorAll('.course-popup').forEach(function (popup) {
      if (popup.dataset.popupBound === 'true') return;
      popup.dataset.popupBound = 'true';

      popup.querySelectorAll('[data-course-popup-close]').forEach(function (closeEl) {
        closeEl.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup(popup);
        });
      });

      const form = popup.querySelector('.course-popup-form');
      if (form) {
        form.addEventListener('submit', async function (e) {
          e.preventDefault();

          if (!form.checkValidity()) {
            form.reportValidity();
            return;
          }

          const submitBtn = form.querySelector('.course-popup-submit');
          const submitText = form.querySelector('.course-popup-submit-text');
          const submitLoader = form.querySelector('.course-popup-submit-loader');
          const successMsg = form.querySelector('.course-popup-success');
          const errorMsg = form.querySelector('.course-popup-error');
          const fieldsContainer = form.querySelector('.course-popup-fields');
          const brochureUrl = popup.dataset.brochureUrl;

          if (submitBtn) submitBtn.disabled = true;
          if (submitText && submitLoader) {
            submitText.style.display = 'none';
            submitLoader.style.display = 'inline';
          }
          if (errorMsg) errorMsg.style.display = 'none';

          try {
            const formData = new FormData(form);
            await fetch(form.action || '/contact', {
              method: 'POST',
              body: formData,
              headers: {
                Accept: 'text/html'
              }
            });

            if (brochureUrl && brochureUrl.length > 0) {
              triggerFileDownload(brochureUrl);
            }

            // Display success status inside popup
            if (fieldsContainer) fieldsContainer.style.display = 'none';
            if (submitBtn) submitBtn.style.display = 'none';
            if (successMsg) successMsg.style.display = 'block';

            // Auto close after 3 seconds and reset form
            setTimeout(function () {
              closePopup(popup);

              setTimeout(function () {
                form.reset();
                if (fieldsContainer) fieldsContainer.style.display = '';
                if (submitBtn) {
                  submitBtn.style.display = '';
                  submitBtn.disabled = false;
                }
                if (submitText && submitLoader) {
                  submitText.style.display = '';
                  submitLoader.style.display = 'none';
                }
                if (successMsg) successMsg.style.display = 'none';
              }, 400);
            }, 3000);
          } catch (err) {
            if (errorMsg) errorMsg.style.display = 'block';
            if (submitBtn) submitBtn.disabled = false;
            if (submitText && submitLoader) {
              submitText.style.display = '';
              submitLoader.style.display = 'none';
            }
          }
        });
      }
    });

    if (!document.documentElement.dataset.coursePopupEscBound) {
      document.documentElement.dataset.coursePopupEscBound = 'true';
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        const activePopup = document.querySelector('.course-popup.is-open');
        if (!activePopup) return;
        activePopup.classList.remove('is-open');
        activePopup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('course-popup-locked');
      });
    }
  }

  // Popup init runs once only — Shopify section:load must not re-register global listeners
  function initOnce() {
    initCoursePortal();
    initCourseBrochurePopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce);
  } else {
    initOnce();
  }

  // On section:load, only re-init section-specific logic (accordions, plan sync)
  // Popup re-init is safe because all handlers guard against double-binding
  document.addEventListener('shopify:section:load', function () {
    initCoursePortal();
    initCourseBrochurePopup();
  });

  // Download links for direct download buttons
  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const btn = target.closest('[data-download]');
    if (!btn) return;

    e.preventDefault();
    triggerFileDownload(btn.href);
  });

  // Restrict phone fields to numbers only in real-time
  document.addEventListener('input', function (e) {
    const target = e.target;
    if (target instanceof HTMLInputElement && (target.type === 'tel' || target.name === 'contact[phone]')) {
      target.value = target.value.replace(/\D/g, '');
    }
  });
})();
